import type { Route } from '@angular/router';
import { EnergyOrderPowerPermissions } from '@backoffice/shared/bo/util-permissions';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { faPlug } from '@fortawesome/pro-solid-svg-icons';
import { ngxPermissionsGuard } from 'ngx-permissions';

const powerListWithPreviewChildren: Route[] = [
  {
    path: 'preview/:id',
    loadComponent: () =>
      import('./components/form/power-form.component').then(
        (mod) => mod.PowerFormComponent,
      ),
    canDeactivate: [CanDeactivateGuard],
  },
];

export const contractTabPowerRoute: Route = {
  path: 'contract',
  loadComponent: () =>
    import('./contract-tabs-power/contract-tabs-power.component').then(
      (mod) => mod.ContractTabsPowerComponent,
    ),
  children: [
    { path: '', redirectTo: 'contracts', pathMatch: 'full' as const },
    {
      path: 'unaccepted-contracts',
      loadComponent: () =>
        import('./power-list.component').then(
          (mod) => mod.ContractPowerListComponent,
        ),
      data: { isUnaccepted: true, hideTitle: true },
      children: powerListWithPreviewChildren,
    },
    {
      path: 'contracts',
      loadComponent: () =>
        import('./power-list.component').then(
          (mod) => mod.ContractPowerListComponent,
        ),
      data: { isUnaccepted: false, hideTitle: true },
      children: powerListWithPreviewChildren,
    },
  ],
  canActivate: [ngxPermissionsGuard],
  data: {
    label: 'customer-pools.fields.CONTRACT',
    permissions: {
      only: EnergyOrderPowerPermissions.tabPermisssion,
    },
  },
};

export const contractPowerRoute: Route = {
  path: 'power',
  loadComponent: () =>
    import('./contract-tabs-power/contract-tabs-power.component').then(
      (mod) => mod.ContractTabsPowerComponent,
    ),
  children: [
    { path: '', redirectTo: 'contracts', pathMatch: 'full' as const },
    {
      path: 'unaccepted-contracts',
      loadComponent: () =>
        import('./power-list.component').then(
          (mod) => mod.ContractPowerListComponent,
        ),
      data: { isUnaccepted: true, hideTitle: true },
      children: powerListWithPreviewChildren,
    },
    {
      path: 'contracts',
      loadComponent: () =>
        import('./power-list.component').then(
          (mod) => mod.ContractPowerListComponent,
        ),
      data: { isUnaccepted: false, hideTitle: true },
      children: powerListWithPreviewChildren,
    },
  ],
  data: {
    translate: 'contracts.power',
    titleIcon: {
      icon: faPlug,
      class: 'power-icon',
    },
  },
};
